import React from 'react';
import parse from 'html-react-parser';
import { ContentParserWrapper } from './ContentParser.styles';
import MarkdownParser from 'react-markdown';

export const ContentParser = ({
  text = '',
  className = '',
  escapeHtml = false,
}: {
  text?: string;
  className?: string;
  escapeHtml?: boolean;
}) => {
  const textHasHtml = /<\/?[a-z][\s\S]*>/i.test(text);
  if (textHasHtml) {
    return <ContentParserWrapper className={className}>{parse(text)}</ContentParserWrapper>;
  } else {
    return (
      <ContentParserWrapper className={className}>
        <MarkdownParser skipHtml={escapeHtml}>{text}</MarkdownParser>
      </ContentParserWrapper>
    );
  }
};
